// src/components/ChatList.js
import React, { useMemo, useState } from 'react';
import { filterHtml, getLastMsgTime } from '../ConversationView';
import _ from 'lodash';
import { getChatUserImage } from '../userList';
import { useSelector } from 'react-redux';
import { getName } from '../messageDetail';
import ConversationViewSkeletonLayout from '../ConversationViewSkeletonLayout';

export default function ChatList({
  chats,
  unreadCounts,
  searchResults,
  onSelect,
  onSearch,
  selected,
}) {
  const [searchQ, setSearchQ] = useState('');
  const { user } = useSelector((state) => state.user);
  const { isChatLoading } = useSelector(state => state.chat)

  const handleSearch = (text) => {
    const trimmed = text.trim();
    onSearch(trimmed);
  };

  // Create a debounced version of handleSearch
  const debouncedSearch = useMemo(() => _.debounce(handleSearch, 300), []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchQ(value);
    debouncedSearch(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      debouncedSearch.flush(); // immediately call if user presses Enter
    }
  };

  // Render either search results or the chat list
  const listItems = searchResults
    ? searchResults.map(({ message, chat }) => (
      <div
        key={message?._id}
        onClick={() => onSelect({ chat, lastMessage: message }, message._id)}
        style={{
          padding: 10,
          cursor: 'pointer',
          borderBottom: '1px solid #eee'
        }}
      >
        <strong>
          {getName(chat, user)}
        </strong>
        <div style={{ fontSize: 12, color: '#555' }}
          dangerouslySetInnerHTML={{ __html: message.content.substr(0, 50) }}
        >
        </div>
      </div>
    ))
    : chats?.sort((a, b) => new Date(b.lastMessage?.updatedAt || 0) - new Date(a.lastMessage?.updatedAt || 0))?.map(({ chat, lastMessage }) => {
      const title = getName(chat, user)
      const badge = unreadCounts[chat._id] || 0;
      return (
        <li
          key={chat?._id}
          id={`convo-${chat._id}`}
          className={selected?.chat?._id === chat._id ? "active" : ""}
          onClick={() => onSelect({ chat, lastMessage })}
        >
          <div
            style={{
              backgroundImage: `url(${getChatUserImage(chat?.participants, user)})`,
            }}
            className="profile_photo"
          ></div>
          <div className="messageDetail">
            <span className="lastSeen">
              {getLastMsgTime(lastMessage?.updatedAt)}
            </span>
            <p className="userName">
              <span>{title}</span>
            </p>
            <p className={`message ${badge > 0 ? "bold" : "light"} `} dangerouslySetInnerHTML={{ __html: filterHtml(lastMessage?.content) || 'Media message' }}></p>
            {badge > 0 && (
              <>
                <span className="messageCount"><span>{badge > 5 ? '5+' : badge}</span></span>
              </>
            )}
          </div>
        </li>
      );
    });

  return (
    <>
      <div className="userListHeader">
        <input
          type="search"
          placeholder="Search..."
          name=""
          id=""
          value={searchQ}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />

      </div>
      <div className="userList chat">
        <ul>
          {isChatLoading ? (<ConversationViewSkeletonLayout type="LEFT" />) :
            listItems}
        </ul>
      </div>
    </>

  );
}
